import Icon from "@components/_Revamp/Icon";
import { css } from "@linaria/core";
import React, { useCallback, useEffect } from "react";
import { themeDefault } from "src/theme-revamp";

interface TooltipProps {
  title: string;
  isIcon?: boolean;
  children: any;
  inlineComponent?: React.ReactChild | JSX.Element;
  inlineTextStyle?: any;
  isFixed?: boolean;
  iconSize?: number;
}

export const Tooltip = (props: TooltipProps) => {
  const { title, isIcon, children, inlineComponent, inlineTextStyle } = props;

  const detectScreenWidth = useCallback(() => {
    setTooltipPosition(window.innerWidth, true, props.isFixed);
  }, [props.isFixed]);

  const scrollWithScreen = useCallback(
    (screenSize?: any, resize?: boolean) => {
      setTooltipPosition(screenSize, resize, props.isFixed);
    },
    [props.isFixed]
  );

  let inlineTextStyleValidated =
    inlineTextStyle instanceof Object ? inlineTextStyle : {};

  useEffect(() => {
    setTooltipPosition(window.innerWidth, true, props.isFixed);
    window.addEventListener("scroll", scrollWithScreen);
    window.addEventListener("resize", detectScreenWidth);
    const scrollElem = document.getElementsByClassName("scrollBlock");
    for (let i = 0; i < scrollElem.length; i++) {
      const elem = scrollElem[i];
      elem.addEventListener("scroll", scrollWithScreen);
    }
    return () => {
      window.removeEventListener("scroll", scrollWithScreen);
      window.removeEventListener("resize", detectScreenWidth);
      for (let i = 0; i < scrollElem.length; i++) {
        const elem = scrollElem[i];
        elem.removeEventListener("scroll", scrollWithScreen);
      }
    };
  }, [props.isFixed, detectScreenWidth, scrollWithScreen]);

  return (
    <span className={isIcon ? `toolTip icon ${Header}` : `toolTip ${Header}`}>
      <span
        id="info"
        style={
          inlineComponent
            ? {
                textUnderlineOffset: "5px",
                textDecorationStyle: "unset",
                textDecorationLine: "unset",
              }
            : {
                color: themeDefault.colors.primary,
                ...inlineTextStyleValidated,
              }
        }
      >
        {inlineComponent ? <>{inlineComponent} </> : <></>}
        {isIcon ? (
          <Icon name="info-gray-solid" width={props.iconSize} />
        ) : inlineComponent ? (
          <></>
        ) : (
          <>{title}</>
        )}
      </span>
      <span className={"top" + (props.isFixed ? " " + FixedStyle : "")}>
        <span className={`tooltipHeader`}>{title}</span>
        {children}
      </span>
    </span>
  );
};

const Header = css`
  .top {
    .tooltipHeader {
      color: #FFFFFF;
    }
    p {
      margin-top: 0px;
    }
  }
  @media screen and (pointer: coarse) {
    .top {
      .tooltipHeader {
        color: #883E89;
      }
    }
  }
`;

const FixedStyle = css`
  position: fixed !important;
`;

const addRemoveGrey = (flag: boolean) => {
  const stepper = document.querySelector("#stepper-bg")!;
  const header = document.querySelector("#singlife-header")!;
  if (flag) {
    stepper && stepper.classList.add("gray_fill");
    header && header.classList.add("gray_fill");
  } else {
    stepper && stepper.classList.remove("gray_fill");
    header && header.classList.remove("gray_fill");
  }
};
export const setTooltipPosition = (
  screenSize?: any,
  resize?: boolean,
  isFixed?: boolean
) => {
  const elems: any = document.querySelectorAll(".toolTip")!;
  const stepper = document.querySelector("#stepper-bg")!;
  const header = document.querySelector("#singlife-header")!;

  if (
    !Array.from<Element>(Object.values(elems)).some((e: any) =>
      e.classList.contains("active")
    )
  ) {
    stepper?.classList.remove("gray_fill");
    header?.classList.remove("gray_fill");
  }

  const MAX_CHILD_ELEMENTS = 3;
  if (elems.length > 0) {
    for (let i = 0; i < elems.length; i++) {
      const topEle = elems[i].querySelector(".top");
      const infoEle = elems[i].querySelector("#info");
      const rectTopEle = topEle.getBoundingClientRect();
      const rect = elems[i].getBoundingClientRect();
      const rectInfoEle = infoEle.getBoundingClientRect();

      if (rect.top < rectTopEle.height + 64) {
        elems[i].classList.add("bottom");
      } else {
        elems[i].classList.remove("bottom");
      }

      if (resize) elems[i].classList.remove("right");
      if (rectTopEle.left > screenSize - rectTopEle.width) {
        elems[i].classList.add("right");
      }
      const inforElementListener = (e: any) => {
        const grayBgElement = document.createElement("span");
        grayBgElement.className = "gray_area";
        addRemoveGrey(true);
        if (elems[i].childElementCount < MAX_CHILD_ELEMENTS) {
          elems[i].appendChild(grayBgElement);
          const grayArea = elems[i].querySelector(".gray_area");

          const grayAreaListener = (e: any) => {
            // grayArea?.removeEventListener('touchend', grayAreaListener)
            // header.removeEventListener('touchend',grayAreaListener)
            elems[i].classList.remove("active");
            addRemoveGrey(false);
          };
          if (header) {
            header.addEventListener("touchend", grayAreaListener);
          }
          if (stepper) {
            stepper.addEventListener("touchend", grayAreaListener);
          }
          if (grayArea) {
            grayArea.addEventListener("touchend", grayAreaListener);
          }
        }
        elems[i].classList.add("active");
        // infoEle?.removeEventListener('touchend', inforElementListener)
      };
      infoEle.addEventListener("touchend", inforElementListener);
      topEle.addEventListener("touchend", (e: any) => {
        elems[i].classList.remove("active");
        addRemoveGrey(false);
      });

      // Check if the device supports hover (usually indicative of a pointing device)
      const hoverQuery = matchMedia("(hover: hover)");
      const supportsHover = hoverQuery.matches;

      // Check if the device supports pointer (indicative of a pointing device)
      const pointerQuery = matchMedia("(pointer: fine)");
      const supportsPointer = pointerQuery.matches;

      const pointerQueryCoarse = matchMedia("(pointer: coarse)");
      const supportsPointerCoarse = pointerQueryCoarse.matches;
      // TODO: Fix this issue with mobile device
      if (
        isFixed &&
        (supportsHover || supportsPointer) &&
        !supportsPointerCoarse
      ) {
        topEle.style.left = rectInfoEle.left - 56 + "px";
        if (rect.top < rectTopEle.height + 64) {
          topEle.style.top = rectInfoEle.top + 60 + "px";
          topEle.style.bottom = "inherit";
          topEle.style.transform = "inherit";
        } else {
          topEle.style.top = rectInfoEle.top - 30 + "px";
          topEle.style.bottom = null;
          topEle.style.transform = null;
        }
      }
    }
  }
};
